import { useDispatch } from 'react-redux';
import ModalType from 'src/constants/modalTypes';
import { showModal } from 'src/modules/shared/modal/actions';

export const useModalTrigger = (modalType: ModalType, modalProps?: any) => {
  const dispatch = useDispatch();
  return () => dispatch(showModal({ modalType, modalProps }));
};
